<div class="row pb-3">
    <div class="col-md-6 d-flex align-items-center" [ngClass]="validoMayuscula?'valid':'invalid'">
        <i [ngClass]="validoMayuscula?'fa-solid fa-circle-check animar':'fa-regular fa-circle-check'"></i>
        <p>Mínimo 1 letra mayúscula</p>
    </div>
    <div class="col-md-6 d-flex align-items-center" [ngClass]="validoMinuscula?'valid':'invalid'">
        <i [ngClass]="validoMinuscula?'fa-solid fa-circle-check':'fa-regular fa-circle-check'"></i>
        <p>Mínimo 1 letra minúscula</p>
    </div>
    <div class="col-md-6 d-flex align-items-center" [ngClass]="validoNumero?'valid':'invalid'">
        <i [ngClass]="validoNumero?'fa-solid fa-circle-check':'fa-regular fa-circle-check'"></i>
        <p>Mínimo 1 número</p>
    </div>
    <div class="col-md-6 d-flex align-items-center" [ngClass]="validoLongitud?'valid':'invalid'">
        <i [ngClass]="validoLongitud?'fa-solid fa-circle-check':'fa-regular fa-circle-check'"></i>
        <p>Mínimo 8 caracteres</p>
    </div>
    <div class="col-md-12 d-flex align-items-center" [ngClass]="validoSimbolo?'valid':'invalid'">
        <i [ngClass]="validoSimbolo?'fa-solid fa-circle-check':'fa-regular fa-circle-check'"></i>
        <p>Mínimo 1 un caracter especial (+*%$)</p>
    </div>
</div>